import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMarkup: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconMarkup"><Path d="M15.4936 16.6921L14.0537 19H21V21H3V17.7295L3.13574 17.4961L6.61962 11.5544L15.4936 16.6921Z" fill="currentColor"/><Path d="M22.1264 8.12918L17.6724 15.6423L6.45165 9.14622L10.8916 1.64551L22.1264 8.12918Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMarkup;
